import { IUnitWithLocationDto } from 'api/api';

export function machineHasPositionOnMap(machineWithLocations: IUnitWithLocationDto[]): boolean {
    return machineWithLocations.some(
        s => (s.gpsLatitude && s.gpsLongitude) || (s.homeLatitude && s.homeLongitude)
    );
}